import { render, staticRenderFns } from "./StudentTable.vue?vue&type=template&id=5b1398fa&scoped=true"
import script from "./StudentTable.vue?vue&type=script&lang=js"
export * from "./StudentTable.vue?vue&type=script&lang=js"
import style0 from "./StudentTable.vue?vue&type=style&index=0&id=5b1398fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1398fa",
  null
  
)

export default component.exports